<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-transparent">
      <!-- Card stats -->
      <div class="row">
        <div class="col-xl-4 col-lg-6">
          <stats-card
            v-if="dashboard"
            title="Total Users"
            type="gradient-red"
            :sub-title="format(dashboard.totalUsers)"
            icon="ni ni-single-02"
            class="mb-4 mb-xl-0 expand-height"
          ></stats-card>
        </div>
        <div class="col-xl-4 col-lg-6">
          <stats-card
            v-if="dashboard"
            title="Daily Viewers"
            type="gradient-orange"
            :sub-title="format(dashboard.dailyViews)"
            icon="ni ni-trophy"
            class="mb-4 mb-xl-0 expand-height"
          ></stats-card>
        </div>
        <div class="col-xl-4 col-lg-6">
          <stats-card
            v-if="dashboard"
            title="Monthly Views"
            type="gradient-green"
            :sub-title="format(dashboard.thisMonthViews)"
            icon="ni ni-sound-wave"
            class="mb-4 mb-xl-0 expand-height"
          ></stats-card>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <!--Tables-->
      <div class="row mt-5">
        <div class="col-xl-12 mb-5">
          <TopFanTable v-if="dashboard" :users="dashboard.topFans" />
        </div>
        <div class="col-xl-12 mb-5">
          <MostViewLiveStreamTable v-if="dashboard" :liveStreams="dashboard.mostViewStreams" />
        </div>
      </div>
      <!--End tables-->
    </div>
  </div>
</template>
<script>
// Tables
import TopFanTable from './Dashboard/TopFanTable'
import MostViewLiveStreamTable from './Dashboard/MostViewLiveStreamTable'

import { mapState } from 'vuex'
import {
  GET_DASHBOARD,
  RESET_AUTH_STATE,
  RESET_USER_STATE,
  RESET_LIVE_STREAM_STATE,
  RESET_COMMENT_STATE,
  RESET_NOTIFICATION_STATE,
  RESET_CLUB_STATE,
  RESET_SCHEDULE_STATE,
  LOGOUT
} from '@/store/actions.type'
import { formatNumber } from '@/common/utils'

export default {
  components: { TopFanTable, MostViewLiveStreamTable },
  mounted() {
    this.$store
      .dispatch(GET_DASHBOARD)
      .then()
      .catch(data => {
        if (data.code === 401) {
          Promise.all([
            this.$store.dispatch(RESET_AUTH_STATE),
            this.$store.dispatch(RESET_USER_STATE),
            this.$store.dispatch(RESET_LIVE_STREAM_STATE),
            this.$store.dispatch(RESET_COMMENT_STATE),
            this.$store.dispatch(RESET_NOTIFICATION_STATE),
            this.$store.dispatch(RESET_CLUB_STATE),
            this.$store.dispatch(RESET_SCHEDULE_STATE),
            this.$store.dispatch(LOGOUT)
          ]).then(() => {
            this.$router.push({ name: 'login' })
          })
        }
      })
  },
  methods: {
    format(number) {
      return formatNumber(number)
    }
  },
  computed: {
    ...mapState({
      dashboard: state => state.auth.dashboard
    })
  }
}
</script>
<style scoped>
.bg-transparent {
  background-color: transparent !important;
}
.expand-height {
  padding: 2rem 1.5rem !important;
}
</style>
